import { createSvgIcon } from '@mui/material';
import { styled } from "@mui/material";

const DashboardIcon = createSvgIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00016 13.2668V2.7335C7.00016 1.7335 6.5735 1.3335 5.5135 1.3335H2.82016C1.76016 1.3335 1.3335 1.7335 1.3335 2.7335V13.2668C1.3335 14.2668 1.76016 14.6668 2.82016 14.6668H5.5135C6.5735 14.6668 7.00016 14.2668 7.00016 13.2668Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6667 5.68016V2.6535C14.6667 1.7135 14.24 1.3335 13.18 1.3335H10.4867C9.42667 1.3335 9 1.7135 9 2.6535V5.6735C9 6.62016 9.42667 6.9935 10.4867 6.9935H13.18C14.24 7.00016 14.6667 6.62016 14.6667 5.68016Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6667 13.18V10.4867C14.6667 9.42667 14.24 9 13.18 9H10.4867C9.42667 9 9 9.42667 9 10.4867V13.18C9 14.24 9.42667 14.6667 10.4867 14.6667H13.18C14.24 14.6667 14.6667 14.24 14.6667 13.18Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>,
  "Dashboard",
);

export const Dashboard = styled(DashboardIcon)(() => ({
  fill: "#fff0",
}));

export default Dashboard;
